import React, { useEffect, useState } from "react";
import { FundEditModal } from "../modals/FundEditModal";
import { FaEdit, FaRegEdit } from "react-icons/fa";
import { isEmpty } from "lodash";
import HierarchicalTable from "./HierarchicalTable";
import axios from "axios";
import Swal from "sweetalert2";
import { DiscardReasonModal } from "../modals/DiscardReasonModal";
import { useSelector } from "react-redux";
import { calculateTotalFloat, formatRupees } from "../../../../utils/inputsValidation";
import api from "../../../../utils/api";
import socket from "../../../../context/socket";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import NomineeDetailsDraft from "../../GoalTracker/modals/NomineeDetailsDraft";
import NomineeOptModal from "../modals/NomineeOptModal";
import { ReferAFriendModal } from "../modals/ReferAFriendModal";

export const TabFour = ({
  setSelectedTab,
  selectedTab,
  setHistoryActiveTab,
  isPortfolioData,
  roomId,
  setSelectedMember,
  selectedMember,
  fetchPortfolioData,
  rowActions, setRowActions
  , schemeCode, setSchemeCode, setActiveTab
}) => {
  const [optNominee, setOptNominee] = useState("Y");
  const [showReferFriendModal, setShowReferFriendModal] = useState(false);

  const [grandTotal, setGrandTotal] = useState({
    totalInvCost: 0,
    totalMarketValue: 0,
    totalGainLoss: 0
  });
  const [bankDetails, setBankDetails] = useState([]);
  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);

  // console.log("clientData", clientData);

  const [allowedReview, setAllowedReview] = useState(false);
  const [allowDiscard, setAllowDiscard] = useState(false);

  const [isPrst, setIsprst] = useState('Draft');
  console.log('isPrst', isPrst);

  const [isGrandtotal, setIsGrandTotal] = useState(0); // Only for CurrentValue

  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  const [perUserEffectiveTotals, setPerUserEffectiveTotals] = useState([]);

  useEffect(() => {
    // console.log("heresssss", isPortfolioData?.result3?.length);
    if (isPortfolioData?.result3?.length > 0) {
      const values = calculateEffiBalTotal();
      setPerUserEffectiveTotals(values); // Save per-user values for child display
    }
  }, [isChecked, isPortfolioData]);

  const getFromDate = (fundNameType, subName) => {
    if (
      (fundNameType === "Equity" && subName !== "Equity - ELSS") ||
      (fundNameType === "Hybrid" && subName !== "Hybrid - Arbitrage")
    ) {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1)); // -12 months
    } else if (
      ["Debt", "Hybrid - Arbitrage", "Others"].includes(fundNameType)
    ) {
      return new Date(); // Today
    } else {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 3)); // -36 months
    }
  };

  const fundtotal = isPortfolioData?.result3;

  // console.log("All Portfolio detail:", fundtotal);

  const calculateEffiBalTotal = () => {
    let total = 0;
    const perUserValues = [];

    fundtotal?.forEach((userData) => {
      let userTotal = 0;

      if (!Array.isArray(userData) || userData.length === 0) return;

      if (isChecked) {
        userData.forEach((user) => {
          const portfolioData = user?.Portfoio
            ? Object.values(user.Portfoio)
            : [];

          portfolioData.forEach((item) => {
            item?.Detail?.forEach((subFund) => {
              subFund?.Detail?.forEach((subFundDetail) => {
                const txns = subFundDetail?.Transaction || [];
                const fundnametype = item["Fund Name"];
                const fundSubName = subFund["Fund Sub Name"];

                let fromDate = new Date();
                if (
                  (fundnametype === "Equity" &&
                    fundSubName !== "Equity - ELSS") ||
                  (fundnametype === "Hybrid" &&
                    fundSubName !== "Hybrid - Arbitrage")
                ) {
                  fromDate.setMonth(fromDate.getMonth() - 12);
                } else if (
                  ["Debt", "Hybrid - Arbitrage", "Others"].includes(
                    fundnametype
                  )
                ) {
                  // no change
                } else {
                  fromDate.setMonth(fromDate.getMonth() - 36);
                }

                const validTypes = [
                  "SIP Purchase",
                  "Purchase",
                  "STP In",
                  "Switch In",
                ];

                txns.forEach((tx) => {
                  const parts =
                    tx["Transaction Date"]?.replace(/-/g, "/")?.split("/") ||
                    [];
                  if (parts.length === 3) {
                    let [dd, mm, yy] = parts;
                    if (yy.length === 2) yy = "20" + yy;
                    const txDate = new Date(`${yy}-${mm}-${dd}`);

                    if (
                      !isNaN(txDate) &&
                      validTypes.includes(tx["Transaction Type"]) &&
                      txDate < fromDate
                    ) {
                      userTotal += parseFloat(tx["Current Value"] || 0);
                    }
                  }
                });
              });
            });
          });
        });
      } else {
        // ✅ use Grand Total -> Current Value when unchecked
        userTotal = parseFloat(
          userData?.[0]?.["Grand Total"]?.["Current Value"] || 0
        );
      }

      perUserValues.push(userTotal.toFixed(2));
      total += userTotal;
    });
    // console.log("im called", isChecked);
    setIsGrandTotal(total.toFixed(2));
    return perUserValues;
  };

  const handleSendWithKYCCheck = () => {
    Swal.fire({
      title: "Please check the client KYC",
      html: `
      <div style="text-align:left;">
        <p><strong>Before proceeding, please verify the client's KYC status:</strong></p>
        <div style="margin-top:10px;">
          <p><strong>Fresh Investment</strong> - KYC Validated</p>
          <p><strong>Existing Investment</strong> - KYC Registered or Validated</p>
          <p><strong>NRI</strong> - KYC Registered</p>
        </div>
      </div>
    `,
      icon: "warning",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      customClass: {
        confirmButton: "swal-confirm-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        sendEvent();
      }
    });
  };

  const handleAddCurrentValue = (val) => {
    setIsGrandTotal((prev) => prev + (val || 0));
  };
  const innerFirstIndexData =
    Array.isArray(fundtotal) && fundtotal.length > 0
      ? Array.isArray(fundtotal[0]) && fundtotal[0].length > 0
        ? fundtotal[0][0]
        : "Inner detail at index [0] is not a valid array or is empty."
      : "Fundtotal is not a valid array or is empty.";

  const portfoioData = innerFirstIndexData?.Portfoio
    ? Object.values(innerFirstIndexData.Portfoio)
    : "Portfoio property not found";

  // console.log("Extracted Portfoio detail:", portfoioData);

  // console.log("isportfoliodata", isPortfolioData);

  // Function to handle "Back" button click
  const handleBack = () => {
    if (selectedTab > 1) {
      setSelectedTab(selectedTab - 1);
    }
  };


  const isPortfolioLoading =
    !isPortfolioData || Object.keys(isPortfolioData).length === 0;



  useEffect(() => {
    const prst = isPortfolioData?.prinfo?.portfolio_review_status ?? null;
    setIsprst(prst)
  }, [isPortfolioData])

  // const allowedReview = ["Draft", "Failed", "Rejected"].includes(prst);
  // const allowDiscard = prst === "Sent";


  React.useEffect(() => {
    // reset both first
    setAllowedReview(false);
    setAllowDiscard(false);

    if (["Draft", "Failed", "Rejected"].includes(isPrst)) {
      setAllowedReview(true);
    } else if (isPrst === "Sent") {
      setAllowDiscard(true);
      // socket.emit("message_to", {
      //   room: roomId,
      //   data: { prst:"Sent" },
      // });
      // console.log('message_to ',isPrst)
    }
  }, [isPrst, setAllowedReview, setAllowDiscard]);

  useEffect(() => {
    socket.on("navigate", ({ room, url }) => {
      if (room === roomId && url) {
        console.log("🔀 Navigation received from socket:", url);
        navigate(url);   // client side navigation
      }
    });

    return () => {
      socket.off("navigate"); // cleanup
    };
  }, [roomId, navigate]);


  useEffect(() => {
    if (allowDiscard) {
      socket.emit("message_to", {
        room: roomId,
        data: { isPrst: "Sent" },
      });
    } else {
      socket.emit("message_to", {
        room: roomId,
        data: { isPrst },
      });
    }
    // console.log('message_to ', isPrst)
  }, [allowDiscard, isPortfolioData, isPrst])


  useEffect(() => {
    const handleAcceptVerification = (msg) => {
      // console.log("📥 Received:", msg);

      if (msg.data === true) {
        // navigate(`/refer-friends?clientId=${roomId}`);
        setShowReferFriendModal(true)


      }
    };

    socket.on("acceptVerification", handleAcceptVerification);

    return () => {
      socket.off("acceptVerification", handleAcceptVerification);
    };
  }, []); // run only once




  const updateClientDates = async (data2) => {
    try {
      const response = await api.put(
        `advisor/update-client-dates`,
        data2
      );
    } catch (error) {
      console.error("Error fetching AllExternal Folios data:", error);
    }
  }



  ///////////////////////////////////////////////

  const [alertMessage, setAlertMessage] = useState({
    visible: false,
    message: "",
    variant: "",
  });
  const [uccQueue, setUccQueue] = useState([]);
  const [currentUccIndex, setCurrentUccIndex] = useState(0);

  const [showNomineeAuthenticationModal, setShowNomineeAuthenticationModal] = useState(false);
  const [nomineeAuthenticationModalData, setNomineeAuthenticationModalData] = useState({ allucccount: "" });

  const [showNomineeOptModal, setShowNomineeOptModal] = useState(false);
  const [nomineeOptModalData, setNomineeOptModalData] = useState([]);


  // Utility function
  function needsNomineeUpdate(nominee) {

    if (!nominee) return false;


    if (nominee.tax_status === "02" || nominee.tax_status === "HUF") {
      return false;
    }
    console.log('nominee', nominee, !nominee.NOM1_IDNO ||
      !nominee.NOM1_ID_TYP ||
      !nominee.NOM1_EMAIL ||
      !nominee.NOM1_ADD1);

    return (
      !nominee.NOM1_IDNO ||
      !nominee.NOM1_ID_TYP ||
      !nominee.NOM1_EMAIL ||
      !nominee.NOM1_ADD1
    );
  }

  // API: fetch nominees
  const checkNominationNew = async (clientId) => {
    try {
      const response = await api.post(`advisor/fetch_all_nominees`, {
        client_id: clientId,
      });
      return response;
    } catch (error) {
      console.error("Error fetching nominees:", error);
      throw error;
    }
  };

  // Goal Event  Send API
  const proceedGoalEvent = async (remark) => {

    const allData = {
      clientid: isPortfolioData.prinfo.client_id,
      pr_id: isPortfolioData.prinfo.portfolio_review_id,
      remark: remark || "",
    };

    try {
      const response = await api.post(`advisor/sendportfolioWm`, allData);
      console.log("Response received:", response.data);

      // setIsSend(false);
      // setIsEdit(true);
      // setIsDiscard(false);
      // getDraftGoalData();

      // 1) Error case — stop flow
      if (response?.data?.isError) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "An error occurred while sending the portfolio.",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        });
        return; // stop here on error
      }

      // 2) Warning case — run fetch only after OK if you want
      if (response?.data?.isWarning) {
        const warnRes = await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Client is not enabled for online transactions.",
          footer: "<b>Please review the portfolio for further details.</b>",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        });

        if (warnRes.isConfirmed) {
          const data2 = {
            _id: roomId,
            action: "pr_date",
            date: new Date(),
          };
          // await updateClientDates(data2);
          setAllowDiscard(true)
          setIsprst('Sent')
          // await fetchPortfolioData(); // runs only when user clicks OK
        }
        return; // done after handling warning
      }

      // 3) Success case — update dates, then fetch after OK
      const okRes = await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Portfolio has been successfully sent to the client for approval.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "swal-confirm-btn" },
      });

      if (okRes.isConfirmed) {
        const data2 = {
          _id: roomId,
          action: "pr_date",
          date: new Date(),
        };
        // updateClientDates(data2);
        setAllowDiscard(true)
        setIsprst('Sent')
        // await fetchPortfolioData(); // only after OK
      }

      // Swal.fire({
      //   title: "Goal Event has been initiated",
      //   icon: null,
      //   confirmButtonText: "OK",
      //   customClass: {
      //     confirmButton: "swal-confirm-btn",
      //   },
      // });
    } catch (error) {
      console.error("Error sending goal event:", error);

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while sending the event.";

      toast.error(errorMessage, {
        style: {
          border: "1px solid #f44336",
          padding: "16px",
          color: "#f44336",
        },
        iconTheme: { primary: "#f44336", secondary: "#fff" },
      });
    }
  };

  // Nominee Modal Flow
  const showNextNomineeModal = (uccQueue, currentUccIndex, setCurrentIndex, remark, opt_no) => {



    if (currentUccIndex >= uccQueue.length) {
      proceedGoalEvent(remark);
      return;
    }
    console.log('uccQueue', uccQueue, currentUccIndex, opt_no);

    const nominee = uccQueue[currentUccIndex];
    const needsUpdate = needsNomineeUpdate(nominee);

    console.log('needsUpdate', needsUpdate);


    if (!needsUpdate) {
      setCurrentIndex((prev) => prev + 1);
      showNextNomineeModal(uccQueue, currentUccIndex + 1, setCurrentIndex);
      return;
    }

    if (opt_no === 'opt_no') {
      // open opt modal
      // setShowNomineeOptModal(true);
      // setNomineeOptModalData({
      //   clientCode: nominee.client_code,
      //   name: nominee.nominee_1_name,
      //   relationship: nominee.nominee_1_relationship,
      //   applicable: nominee.nominee_1_applicable_,
      //   opt: nominee.nomination_opt,
      //   // mobile: nominee.NOM1_MOB,
      //   // email: nominee.NOM1_EMAIL,
      //   // address: nominee.NOM1_ADD1,
      //   // city: nominee.NOM1_CITY,
      // })
    } else {

      //  modal open
      setShowNomineeAuthenticationModal(true);

      setNomineeAuthenticationModalData({
        clientCode: nominee.client_code,
        name: nominee.nominee_1_name,
        relationship: nominee.nominee_1_relationship,
        applicable: nominee.nominee_1_applicable_,
        mobile: nominee.NOM1_MOB,
        email: nominee.NOM1_EMAIL,
        address: nominee.NOM1_ADD1,
        city: nominee.NOM1_CITY,
        pincode: nominee.NOM1_PIN,
        idType: nominee.NOM1_ID_TYP,
        idNo: nominee.NOM1_IDNO,
      })
    }


  };

  // sendEvent main function
  const sendEvent = async (remark) => {
    console.log('remark', remark);

    try {
      const response = await checkNominationNew(roomId);
      const res = response?.data
      // console.log("Nominees API:",res);

      const appOk = (typeof res?.status === "string" && res.status.toLowerCase() === "success")
        || res?.success === true || res?.status === 200;



      const nominees = Array.isArray(res?.data) ? res.data : Array.isArray(res?.data) ? res?.data : [];
      // const nominee_opt_no = Array.isArray(res?.data) ? res.nominee_opt_no : Array.isArray(res?.nominee_opt_no) ? res?.nominee_opt_no : [];
     const nominee_opt_no = Array.isArray(res?.nominee_opt_no)? res.nominee_opt_no: [];
      console.log("Nominees API:", nominee_opt_no);

      if (appOk && nominees.length > 0) {
        // console.log("Nominees API:", res, appOk, nominees);

        setUccQueue(nominees);
        setCurrentUccIndex(0);
        showNextNomineeModal(nominees, 0, setCurrentUccIndex, remark);

      }
      else if (appOk && nominee_opt_no.length > 0) {
        console.log("nominee_opt_no:", nominee_opt_no);
        setShowNomineeOptModal(true)
        setNomineeOptModalData(res?.nominee_opt_no)
        // setUccQueue(nominee_opt_no);
        // setCurrentUccIndex(0);
        // showNextNomineeModal(nominee_opt_no, 0, setCurrentUccIndex, remark, 'opt_no');
      }
    
      else {
        // Swal.fire("Info", "No nominee data found.", "info");
        proceedGoalEvent(remark);
      }
    } catch (err) {
      console.error("fetch_all_nominees error:", err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch nominees. Please try again.";

      toast.error(msg);
    }
  };



  const handleResend = async () => {
    try {
      const { value: remark } = await Swal.fire({
        title: "Enter Remark",
        input: "text",
        inputLabel: "Please enter your remark before resending.",
        inputPlaceholder: "Type your remark here...",
        showCancelButton: true,
        confirmButtonText: "Send",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value) {
            return "Remark is required!";
          }
        },
      });

      if (remark) {
        Swal.fire({
          title: "Sending...",
          text: "Please wait while we resend the data.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        await sendEvent(remark);

        Swal.fire({
          icon: "success",
          title: "Resent Successfully!",
          text: "Your data has been resent with remark.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Something went wrong while resending.",
      });
      console.error("Resend error:", error);
    }
  };

  ////////////////////////////////////////////



  // const handleSendPortFolio = async () => {
  //   const allData = {
  //     clientid: isPortfolioData.prinfo.client_id,
  //     pr_id: isPortfolioData.prinfo.portfolio_review_id,
  //     remark: "",
  //   };



  //   try {
  //     const { data } = await api.post(
  //       `advisor/sendportfolioWm`,allData
  //     );

  //     // 1) Error case — stop flow
  //     if (data?.isError) {
  //       await Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text: data?.message || "An error occurred while sending the portfolio.",
  //         confirmButtonText: "OK",
  //         customClass: { confirmButton: "swal-confirm-btn" },
  //       });
  //       return; // stop here on error
  //     }

  //     // 2) Warning case — run fetch only after OK if you want
  //     if (data?.isWarning) {
  //       const warnRes = await Swal.fire({
  //         icon: "warning",
  //         title: "Warning",
  //         text: "Client is not enabled for online transactions.",
  //         footer: "<b>Please review the portfolio for further details.</b>",
  //         confirmButtonText: "OK",
  //         customClass: { confirmButton: "swal-confirm-btn" },
  //       });

  //       if (warnRes.isConfirmed) {
  //         const data2 = {
  //           _id: roomId,
  //           action: "pr_date",
  //           date: new Date(),
  //         };
  //         await updateClientDates(data2);
  //         setAllowDiscard(true)
  //         setIsprst('Sent')
  //         // await fetchPortfolioData(); // runs only when user clicks OK
  //       }
  //       return; // done after handling warning
  //     }

  //     // 3) Success case — update dates, then fetch after OK
  //     const okRes = await Swal.fire({
  //       icon: "success",
  //       title: "Success",
  //       text: "Portfolio has been successfully sent to the client for approval.",
  //       confirmButtonText: "OK",
  //       customClass: { confirmButton: "swal-confirm-btn" },
  //     });

  //     if (okRes.isConfirmed) {
  //       const data2 = {
  //         _id: roomId,
  //         action: "pr_date",
  //         date: new Date(),
  //       };
  //       updateClientDates(data2);
  //       setAllowDiscard(true)
  //       setIsprst('Sent')
  //       // await fetchPortfolioData(); // only after OK
  //     }
  //   }catch (error) {
  //     // Handle API call errors
  //     console.error("Error sending portfolio data:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Network Error",
  //       text: "Unable to send the portfolio. Please try again later.",
  //       confirmButtonText: "OK",
  //       customClass: {
  //         confirmButton: "swal-confirm-btn",
  //       },
  //     });
  //   }
  // };

  const [isShowDiscardReasonModal, setIsShowDiscardReasonModal] = useState(false);

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;

    const selectedData = bankDetails.find(
      (member) => member._id === selectedId
    );
    // console.log("selectedData", selectedData);
    setSelectedMember(selectedData);
    setSelectedTab(1);
  };
  // console.log("selectedMember", selectedMember, isPortfolioData);


  const handelPushToArchive = async (prId) => {
    if (!prId) {
      await Swal.fire({
        icon: "error",
        title: "Missing PR ID"
      });
      return;
    }

    // Step 1: Confirm + get remark
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will archive the portfolio review as 'Partially Executed'. Proceed?",
      icon: "warning",
      input: "textarea",
      inputPlaceholder: "Add a remark (required)",
      inputAttributes: {
        "aria-label": "Archive remark",
        maxlength: 500,
      },
      inputValidator: (v) => (!v?.trim() ? "Please enter a remark." : undefined),
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "No",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (!result.isConfirmed) return;

    const remark = result.value.trim();

    // Step 2: Show loader while calling API
    Swal.fire({
      title: "Archiving...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const res = await api.post("advisor/pushToArchive", {
        client_id: roomId,
        portfolio_review_id: prId,
        remark,
      });

      Swal.close();

      // ✅ Check archived response
      if (res?.data?.archived === "Passed") {
        await Swal.fire({
          icon: "success",
          title: "Archived",
          text: res?.data?.message || "Portfolio review archived successfully.",
        });
        setSelectedTab(1);
        fetchPortfolioData();
        socket.emit("execute", {
          room: roomId,
          message: "Transaction Archived successfully",
          archived: true,
        });
      } else if (res?.data?.archived === "Failed") {
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.data?.message || "Portfolio review could not be archived.",
        });
      } else {
        await Swal.fire({
          icon: "warning",
          title: "Unexpected Response",
          text: JSON.stringify(res?.data) || "Server returned unknown status.",
        });
      }
    } catch (err) {
      Swal.close();
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || err.message || "Something went wrong.",
      });
    }
  };



  useEffect(() => {
    getInvestor();
  }, []);

  // Fetch Investor Name fund list from API
  const getInvestor = async () => {
    try {
      const response = await api.get(
        `advisor/gethouseHoldPanInfo/${roomId}`
      );
      setBankDetails(response.data);
      // console.log("BankDetails", response.data);
    } catch (error) {
      console.error("Error fetching AMC fund list:", error);
    }
  };
  useEffect(() => {
    // Ensure isPortfolioData exists and has result3
    // if (!isPortfolioData?.result3 || isPortfolioData.result3.length === 0)
    //   return;

    setGrandTotal(isPortfolioData?.result3?.grandTotals);
  }, [isPortfolioData?.result3?.length]);


  const nomineeDetailsModalHide = () => {
    setShowNomineeAuthenticationModal(false);
    setAlertMessage({ visible: false });
  };


  // when client exexute
  useEffect(() => {
    socket.on("execute", (msg) => {
      console.log("Received Execute Data:", msg);
      if (msg?.data == true) {
        // const nextUrl = `/refer-friends/?clientId=${roomId}`;
        // socket.emit("navigate", { room: roomId, url: nextUrl });
        // navigate(nextUrl);
        setTimeout(() => {
          fetchPortfolioData()
          setShowReferFriendModal(true)
        },20000)

        // return;
      }
      // console.log("Transaction Data:", msg.data,msg,msg?.data?.success);
    });
    // Cleanup on unmount
    return () => {
      socket.off("execute");
    };
  }, []);
  return (
    <>
      <NomineeDetailsDraft
        show={showNomineeAuthenticationModal}
        nomineeAuthenticationModalData={nomineeAuthenticationModalData}
        onHide={nomineeDetailsModalHide}
        setAlertMessage={setAlertMessage}
        alertMessage={alertMessage}
        proofType={"Nominee"}
        clientData={clientData}
        roomId={roomId}
      />
      <NomineeOptModal
        show={showNomineeOptModal}
        nomineeOptModalData={nomineeOptModalData}
        onHide={() => setShowNomineeOptModal(false)}
        proceedGoalEvent={proceedGoalEvent}
        // setAlertMessage={setAlertMessage}
        // alertMessage={alertMessage}
        proofType={"Nominee"}
        clientData={clientData}
        roomId={roomId}
      />
      <DiscardReasonModal
        show={isShowDiscardReasonModal}
        setSelectedTab={setSelectedTab}
        advisorId={clientData.advisor_id}
        onHide={() => setIsShowDiscardReasonModal(false)}
        isPortfolioData={isPortfolioData}
        fetchPortfolioData={fetchPortfolioData}
        setHistoryActiveTab={setHistoryActiveTab}
        setActiveTab={setActiveTab}
      />
      <div className="container" style={{ minHeight: "500px" }}>
        {isPortfolioLoading ? (
          <></>
        ) : (

          <>
            <div className="row">
              <div className="col">
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="home-tab-pane"
                    role="tabpanel"
                  >
                    <div className="row pb-4 align-items-center">
                      {/* Left Side: Label & Dropdown */}
                      <div className="col-md-6 col-12 mb-2">
                        <label className="fs-14 fw-normal clrlight">
                          Live portfolio of
                        </label>
                        <select
                          className="form-select w-50 w-md-25"
                          aria-label="Default select example"
                          onChange={handleSelectChange}
                          value={selectedMember?._id}
                        >
                          {!bankDetails?.some(
                            (member) => member.type === "Individual"
                          ) && <option value="all_Household">Household</option>}

                          {bankDetails?.map((member) => (
                            <option key={member._id} value={member._id}>
                              {member.client_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row  d-md-block">
                      {isPortfolioData?.result3?.users.map((item, index) => (
                        <div key={index}>
                          {/* {item?.username} */}
                          <HierarchicalTable
                            userData={item}
                            rowActions={rowActions} setRowActions={setRowActions}
                            isPortfolioData={isPortfolioData}
                            schemeCode={schemeCode} setSchemeCode={setSchemeCode}
                            onlyone={index === 0 ? "yes" : "no"}
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            effectiveValue={
                              perUserEffectiveTotals?.[index] || 0
                            }
                            allowedReview={allowedReview}
                            fetchPortfolioData={fetchPortfolioData}
                          />
                        </div>
                      ))}

                      {/* {isPortfolioData?.result3.map((item, index) => (
                        <div key={index}>
                          <HierarchicalTable
                            allowedReview={allowedReview}
                            schemeCode={schemeCode} setSchemeCode={setSchemeCode}
                           
                            onlyone={index === 0 ? "yes" : "no"}
                            userData={item}
                            isPortfolioData={isPortfolioData}
                            fetchPortfolioData={fetchPortfolioData}
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            effectiveValue={
                              perUserEffectiveTotals?.[index] || 0
                            } 
                          />
                        </div>
                      ))} */}
                    </div>


                    {!selectedMember?.wo_id && (
                      <>
                        {/* Grand Total Row (desktop only) */}
                        <div className="d-none d-md-block mb-5">
                          <div className="d-flex w-100 align-items-center bg-light ps-2 py-2 border-top border-bottom">

                            <div style={{ width: "20%" }} className="fw-bold">
                              Grand Total
                            </div>

                            <div style={{ width: "10%" }} className="fw-bold text-end pe-2">
                              {formatRupees(grandTotal?.totalInvCost || 0)}
                            </div>

                            <div style={{ width: "14%" }} className="fw-bold text-end pe-2">
                              {formatRupees(grandTotal?.totalMarketValue || 0)}
                            </div>

                            <div style={{ width: "10%" }} className="fw-bold text-end pe-2">
                              {formatRupees(grandTotal?.totalGainLoss || 0)}
                            </div>

                            <div style={{ width: "10%" }} className="fw-bold text-end pe-2">
                              {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                            </div>

                            <div style={{ width: "10%" }} className="fw-bold text-end pe-2">
                              {calculateTotalFloat(grandTotal?.absReturn).toFixed(2)}%
                            </div>

                            <div style={{ width: "10%" }}></div>

                            <div style={{ width: "16%" }}></div>
                          </div>
                        </div>

                        {/* For Mobile view  Start*/}
                        <div className="row my-5 d-block d-md-none">
                          <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                            <div className="d-flex justify-content-between my-3  ">
                              <strong>Grand Total</strong>

                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Inv Cost</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.totalInvCost)}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Current Val</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.totalMarketValue)}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Gain/Loss</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.totalGainLoss)}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>XIRR</span>
                              <span className="text-color-green">
                                {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Abs Return</span>
                              <span className="text-color-green">
                                {calculateTotalFloat(grandTotal?.absReturn).toFixed(2)}%
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* For Mobile view End */}
                      </>
                    )}
                    {/* Buttons */}
                    <div id="actiocentercls" className="mt-5" style={{ textAlign: "center" }}>
                      {/* {allowedReview && ( */}
                      <>
                        {isPrst === "Draft" && (
                          <button
                            className="lrgbutton upercase  text-white"
                            id="validatesubmit"
                            // onClick={handleSendPortFolio}
                            onClick={handleSendWithKYCCheck}
                          >
                            Send
                          </button>
                        )}

                        {((isPrst === "Failed") || (isPrst === "Rejected")) && (
                          <button
                            className="lrgbutton upercase  text-white "
                            id="validatesubmitresent"
                            onClick={(e) => handleResend()}
                          >
                            Resend
                          </button>
                        )}
                      </>
                      {/* )} */}
                      {/* {allowDiscard && ( */}
                      {(isPrst === "Sent" || isPrst === "Resent") && (
                        <button
                          className="lrgbutton upercase  text-white ms-2"
                          id="rechangeportfolio"
                          onClick={() => setIsShowDiscardReasonModal(true)}
                        >
                          Discard
                        </button>

                      )}
                      {/* <button className="lrgbutton upercase  text-white ms-2" id="rechangeportfolio" onClick={()=>setIsShowDiscardReasonModal(true)}>
            Discard
            </button> */}

                      {(isPortfolioData?.prinfo?.accepted_once || isPrst === "Failed") && (
                        <button
                          className="lrgbutton upercase  text-white ms-2"
                          id="pushToArchive"
                          onClick={() => handelPushToArchive(isPortfolioData?.prinfo?.portfolio_review_id)}
                        >
                          Archive
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {!isPortfolioLoading && (
        <div className="container">
          <div className="row">
            <div className="col text-end">
              <a
                href="javascript:void(0);"
                onClick={handleBack}
                disabled={selectedTab === 1}
              >
                <img
                  className="arrow_next1"
                  src="assets/images/left-arrowpng.png"
                  alt="Back"
                />
              </a>
            </div>
          </div>
        </div>
      )}


      <ReferAFriendModal
        show={showReferFriendModal}
        onHide={() => setShowReferFriendModal(false)}
        roomId={roomId}
      />
    </>
  );
};
